import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Agencia, ContaBancariaRequest, ContaBancariaResponse } from './banco.model';

@Injectable({
  providedIn: 'root',
})
export class BancoService {
  private readonly apiUrl = `${environment.fullApiUrl}/banco`;
  private readonly http = inject(HttpClient);

  obterAgencias(coBanco: string, coMunicipioIbge: string): Observable<Agencia[]> {
    const params = new HttpParams()
      .set('co_banco', coBanco)
      .set('co_municipio_ibge', coMunicipioIbge);
    return this.http.get<Agencia[]>(`${this.apiUrl}/agencias`, { params });
  }

  obterContaBancaria(): Observable<ContaBancariaResponse | null> {
    return this.http.get<ContaBancariaResponse | null>(`${this.apiUrl}/me`);
  }

  salvarContaBancaria(payload: ContaBancariaRequest): Observable<ContaBancariaResponse> {
    return this.http.post<ContaBancariaResponse>(`${this.apiUrl}/conta-bancaria`, payload);
  }

  atualizarContaBancaria(id: number, payload: ContaBancariaRequest): Observable<ContaBancariaResponse> {
    return this.http.put<ContaBancariaResponse>(`${this.apiUrl}/conta-bancaria/${id}`, payload);
  }

  verificarAcesso(): Observable<{ permitido: boolean }> {
    return this.http.get<{ permitido: boolean }>(`${this.apiUrl}/verificar-acesso`);
  }
}

